import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import {
  CarrierJob,
  ContainerTypeRead,
  JobCreate,
  JobSearchFilter,
  JobSearchResult,
  JobUpdate,
  LoadTypeRead,
  ShipperJob,
  SpecialRequirementRead,
  SuperAdminJob,
  TrackRouteRequest,
} from '../../models/job';

import { LoadTrace } from '../../models/load';
import type { DrivingRoute } from '../../models/route';
import { JobAvailableVehicle, VehicleTypeRead } from '../../models/vehicle';
import { QuoteCreate, QuoteUpdate } from '../../models/quote';
import { LoadStatusEnum } from '../../enums/load';

export const jobEvents = eventGroup({
  source: 'Job',
  events: {
    clear: type<void>(),
    setLoading: type<boolean>(),
    createJob: type<JobCreate>(),
    createJobSucess: type<boolean>(),
    createJobFailure: type<boolean>(),
    updateJobSucess: type<boolean>(),
    updateJobFailure: type<boolean>(),
    loadAvailableVehiclesList: type<void>(),
    loadedAvailableVehiclesList: type<JobAvailableVehicle[]>(),
    selectJob: type<ShipperJob | null>(),
    searchJob: type<JobSearchFilter | null>(),
    loadedSearchResult: type<JobSearchResult[]>(),
    clearSearchResult: type<void>(),
    loadAllSuperAdminJobsList: type<{
      startDate: Date;
      endDate: Date;
      pageSize: number;
      page: number;
    }>(),
    loadedAllSuperAdminJobsList: type<SuperAdminJob[]>(),
    loadAllCarrierJobsList: type<{
      startDate: Date;
      endDate: Date;
      pageSize: number;
      page: number;
    }>(),
    loadedAllCarrierJobsList: type<CarrierJob[]>(),
    loadInprogressCarrierJobsList: type<string>(),
    // loadedInprogressCarrierJobsList: type<{
    //   inprogressCarrierJobsList: CarrierInprogressJobs[];
    // }>(),
    loadAllShipperJobsList: type<{
      startDate: Date;
      endDate: Date;
      pageSize: number;
      page: number;
    }>(),
    loadedAllShipperJobsList: type<ShipperJob[]>(),
    loadShipperAcceptedQuotesList: type<{
      shipperSub: string;
      jobId: number;
    }>(),
    loadVehicleTypesList: type<{ pageSize: number; page: number }>(),
    loadedVehicleTypesList: type<VehicleTypeRead[]>(),
    loadContainertypes: type<{ pageSize: number; page: number }>(),
    loadedContainertypes: type<ContainerTypeRead[]>(),
    loadSpecialRequirements: type<{ pageSize: number; page: number }>(),
    loadedSpecialRequirements: type<SpecialRequirementRead[]>(),
    loadLoadTypes: type<{ pageSize: number; page: number }>(),
    loadedLoadTypes: type<LoadTypeRead[]>(),
    updateJob: type<{
      jobId: number;
      payload: JobUpdate;
    }>(),
    saUpdateJob: type<{ jobId: number; payload: Record<string, unknown> }>(),
    deleteJob: type<{ shipperSub: string; jobId: number }>(),
    createQuote: type<QuoteCreate>(),
    updateQuote: type<QuoteUpdate>(),
    assignLoadVehicle: type<{ vehicle_id: number; load_id: number }>(),
    setLoadStatus: type<{
      load_id: number;
      status: LoadStatusEnum;
      remark?: string;
    }>(),
    approveLoadCompletion: type<{ load_id: number; remark?: string }>(),
    loadCompletionApproved: type<{ load_id: number; completed_at: string }>(),
    deleteLoadStatus: type<{
      loadId: number;
      status: LoadStatusEnum;
    }>(),
    loadLoadTraceList: type<{
      startDate: Date;
      endDate: Date;
      pageSize: number;
      page: number;
    }>(),
    loadedLoadTraceList: type<LoadTrace[]>(),
    loadTrackRoute: type<TrackRouteRequest>(),
    loadedTrackRoute: type<DrivingRoute | null>(),
  },
});
